/**
 * Для запросов к API (ожидается ответ в формате JSON)
 * @namespace helpers/httpClient
 */

import * as queryString from 'query-string';

import { error } from './notificationHelper';

const options = {
  headers: {
    Accept: 'application/json',
    'cache-control': 'no-cache',
  },
  credentials: 'include', // include, *same-origin, omit
  mode: 'cors',
};
declare const PRODUCTION: boolean;

function getHost() {
  if (location.host === 'pohodnik.github.io') return `https://pohodnik58.ru`;
  return PRODUCTION ? '' : '';
}

/**
 * Выполняет GET запрос к серверу
 * @param url
 * @param data
 * @param opts
 * @returns {Promise<any>}
 */
export async function get<R = any, T = any>(
  url: string,
  data?: T,
  opts: RequestInit = {},
): Promise<R> {
  const fullUrl = `${getHost()}${url}`;
  const res = await fetch(
    `${fullUrl}${data ? '?' : ''}${data ? queryString.stringify(data) : ''}`,
    {
      ...options,
      ...opts,
      headers: {
        ...options.headers,
        ...opts.headers,
        Authorization: 'Bearer ' + localStorage.getItem('token'),
      },
    } as RequestInit,
  );

  const resJSON = await res.json();

  return resJSON;
}

/**
 * Выполняет POST запрос к серверу
 * @param {string} url адрес
 * @param data
 * @param opts
 * @returns {Promise<any>}
 */
export function post<R = any, T = any | undefined>(
  url: string,
  data: T,
  opts: RequestInit = {},
  variant: 'formdata' | 'json' = 'formdata',
): Promise<R> {
  const fullUrl = `${getHost()}${url}`;
  let body;

  switch (variant) {
    case 'formdata':
      if (data) {
        const formData = new FormData();
        Object.entries(data).forEach(([key, value]) => {
          if (Array.isArray(value)) {
            value.forEach((v) => formData.append(`${key}[]`, v ?? ''));
          } else {
            formData.append(key, (value as any) ?? '');
          }
        });
        body = formData;
      }
      break;
    case 'json':
      body = JSON.stringify(data);
      break;
  }

  return fetch(fullUrl, {
    ...options,
    ...opts,
    method: 'POST',
    body,
    headers: {
      ...options.headers,
      ...opts.headers,
      Authorization: 'Bearer ' + localStorage.getItem('token'),
    },
  } as RequestInit).then((res) => res.json());
}

export function httpResult(response: Response | any) {
  return new Promise((resolve, reject) => {
    if (!response) {
      error('Упс... Что-то пошло не так...');
      reject(response);
      return;
    }
    if (response?.error) {
      error(response.error);
      reject(response);
      return;
    }
    if (response?.err) {
      error(response.err);
      reject(response);
      return;
    }

    resolve(response);
  });
}

export function handleApiError<T = any>(response: Response | any): Promise<T> {
  return new Promise((resolve, reject) => {
    if (response && response.error) {
      reject(new Error(response.error));
    }

    resolve(response as T);
  });
}

export default { get, post };
